import { useState } from "react";

const SITES = [
  // FRONT VIEW
  { id: "abdomen", view: "front", label: "Abdomen (belly fat)", type: "SubQ", cx: 100, cy: 165,
    notes: "Most-used site — large subQ fat layer, easy self-access. Stay 2 in / 5cm away from navel." },
  { id: "love-handle", view: "front", label: "Love handle / flank", type: "SubQ", cx: 138, cy: 158,
    notes: "Great alternate to belly. Pinch the side fat & inject into the fold." },
  { id: "outer-thigh", view: "front", label: "Outer thigh", type: "SubQ", cx: 78, cy: 250,
    notes: "Front-outer quad. SubQ if pinching fat, IM if going deeper. Sit with leg relaxed." },
  { id: "upper-arm", view: "front", label: "Upper outer arm", type: "SubQ", cx: 50, cy: 115,
    notes: "Tricep area. Requires a helper or steady angle for self-injection." },
  { id: "deltoid", view: "front", label: "Deltoid (shoulder)", type: "IM", cx: 152, cy: 95,
    notes: "Intramuscular only — used for HCG, TB-500, B12. 1\" needle at 90°, mid-deltoid." },
  { id: "ventrogluteal", view: "front", label: "Ventrogluteal (hip)", type: "IM", cx: 145, cy: 195,
    notes: "Pro-preferred IM site — palm on hip-bone, index toward groin, middle finger up: inject in the V." },
  // BACK VIEW
  { id: "upper-buttock", view: "back", label: "Upper outer buttock", type: "IM", cx: 75, cy: 230,
    notes: "Classic IM site — upper-outer quadrant of the glute. 1-1.5\" needle." },
  { id: "lower-back", view: "back", label: "Lower-back flank", type: "SubQ", cx: 130, cy: 180,
    notes: "Alternate to love handle — pinch the soft tissue above the hip bone." },
  { id: "post-deltoid", view: "back", label: "Posterior deltoid", type: "IM", cx: 45, cy: 95,
    notes: "Back of the shoulder. Solid IM alt when front deltoid is sore." },
  { id: "tricep", view: "back", label: "Tricep (back of arm)", type: "SubQ", cx: 155, cy: 120,
    notes: "Pinch the back of the upper arm. Easy with a helper, harder solo." },
];

const SITE_COLORS = { SubQ: "#CCFF00", IM: "#00E5FF" };

const FRONT_PATHS = {
  head: <circle cx="100" cy="40" r="22" fill="none" stroke="#3A3A3A" strokeWidth="1.5" />,
  neck: <rect x="93" y="60" width="14" height="12" fill="#1A1A1A" />,
  torso: <path d="M 60 72 Q 60 70 70 70 L 130 70 Q 140 70 140 72 L 150 100 Q 155 130 152 170 Q 148 200 145 215 L 115 215 Q 110 218 100 218 Q 90 218 85 215 L 55 215 Q 52 200 48 170 Q 45 130 50 100 Z" fill="#121212" stroke="#3A3A3A" strokeWidth="1.5" />,
  armL: <path d="M 50 100 Q 40 105 38 130 Q 36 155 42 175 L 50 175 Q 52 155 54 130 Q 56 110 60 100 Z" fill="#121212" stroke="#3A3A3A" strokeWidth="1.5" />,
  armR: <path d="M 150 100 Q 160 105 162 130 Q 164 155 158 175 L 150 175 Q 148 155 146 130 Q 144 110 140 100 Z" fill="#121212" stroke="#3A3A3A" strokeWidth="1.5" />,
  legL: <path d="M 60 215 Q 58 215 58 220 L 65 320 Q 67 350 74 360 L 88 360 Q 90 340 90 320 L 92 220 Q 92 215 88 215 Z" fill="#121212" stroke="#3A3A3A" strokeWidth="1.5" />,
  legR: <path d="M 140 215 Q 142 215 142 220 L 135 320 Q 133 350 126 360 L 112 360 Q 110 340 110 320 L 108 220 Q 108 215 112 215 Z" fill="#121212" stroke="#3A3A3A" strokeWidth="1.5" />,
};

// Back view = mirrored torso with glute swell + no facial features
const BACK_PATHS = {
  head: <circle cx="100" cy="40" r="22" fill="#1A1A1A" stroke="#3A3A3A" strokeWidth="1.5" />,
  neck: <rect x="93" y="60" width="14" height="12" fill="#1A1A1A" />,
  torso: <path d="M 60 72 Q 60 70 70 70 L 130 70 Q 140 70 140 72 L 150 100 Q 155 130 152 170 Q 148 200 145 215 L 115 215 Q 110 218 100 218 Q 90 218 85 215 L 55 215 Q 52 200 48 170 Q 45 130 50 100 Z" fill="#121212" stroke="#3A3A3A" strokeWidth="1.5" />,
  spine: <line x1="100" y1="78" x2="100" y2="210" stroke="#2A2A2A" strokeWidth="1.5" strokeDasharray="2 3" />,
  armL: <path d="M 50 100 Q 40 105 38 130 Q 36 155 42 175 L 50 175 Q 52 155 54 130 Q 56 110 60 100 Z" fill="#121212" stroke="#3A3A3A" strokeWidth="1.5" />,
  armR: <path d="M 150 100 Q 160 105 162 130 Q 164 155 158 175 L 150 175 Q 148 155 146 130 Q 144 110 140 100 Z" fill="#121212" stroke="#3A3A3A" strokeWidth="1.5" />,
  glute: <path d="M 55 215 Q 50 230 55 250 Q 70 258 95 252 L 105 252 Q 130 258 145 250 Q 150 230 145 215 Z" fill="#1A1A1A" stroke="#3A3A3A" strokeWidth="1.5" />,
  legL: <path d="M 60 245 Q 58 250 58 255 L 65 320 Q 67 350 74 360 L 88 360 Q 90 340 90 320 L 92 255 Q 92 250 88 245 Z" fill="#121212" stroke="#3A3A3A" strokeWidth="1.5" />,
  legR: <path d="M 140 245 Q 142 250 142 255 L 135 320 Q 133 350 126 360 L 112 360 Q 110 340 110 320 L 108 255 Q 108 250 112 245 Z" fill="#121212" stroke="#3A3A3A" strokeWidth="1.5" />,
};

const ROUTE_LABEL = { SubQ: "Subcutaneous", IM: "Intramuscular" };

function siteRadius({ isActive, isRecommended }) {
  if (isActive) return 6;
  if (isRecommended) return 5;
  return 4.5;
}

export default function InjectionSites({ recommendedRoute = null, peptideName = null }) {
  const [view, setView] = useState("front");
  const [active, setActive] = useState("abdomen");

  const visibleSites = SITES.filter((s) => s.view === view);
  // If switching view + previously-active site isn't visible, auto-select first
  const safeActive = visibleSites.find((s) => s.id === active) ? active : visibleSites[0].id;
  const safeSite = SITES.find((s) => s.id === safeActive);

  function switchView(v) {
    setView(v);
    const firstOfView = SITES.find((s) => s.view === v);
    if (firstOfView) setActive(firstOfView.id);
  }

  const paths = view === "front" ? FRONT_PATHS : BACK_PATHS;
  const highlightColor = recommendedRoute ? SITE_COLORS[recommendedRoute] : null;
  const recommendedLabel = ROUTE_LABEL[recommendedRoute] || null;

  return (
    <div data-testid="injection-sites" className="bg-[#0A0A0A] border border-[#262626] rounded-lg p-6 sm:p-8">
      {recommendedRoute && peptideName && (
        <div
          data-testid="route-banner"
          className="flex items-center gap-3 mb-5 px-4 py-3 rounded-md font-mono-data text-xs"
          style={{ background: `${highlightColor}1A`, border: `1px solid ${highlightColor}55`, color: highlightColor }}
        >
          <span className="text-base leading-none">★</span>
          <span>
            <strong style={{ color: highlightColor }}>{peptideName}</strong> is dosed{" "}
            <strong style={{ color: highlightColor }}>{recommendedLabel}</strong> — matching sites are pulsing on the body map below.
          </span>
        </div>
      )}

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 items-center">
        {/* Body illustration */}
        <div className="flex flex-col items-center">
          {/* Front/Back toggle */}
          <div className="inline-flex bg-[#121212] border border-[#262626] rounded-full p-1 mb-4">
            {["front", "back"].map((v) => (
              <button
                key={v}
                data-testid={`view-${v}`}
                onClick={() => switchView(v)}
                className={`px-4 py-1.5 rounded-full text-xs font-bold uppercase tracking-wider transition-colors ${
                  view === v ? "bg-[#CCFF00] text-black" : "text-[#A3A3A3] hover:text-white"
                }`}
              >
                {v}
              </button>
            ))}
          </div>

          <svg viewBox="0 0 200 380" className="w-48 sm:w-56" aria-label={`Injection sites — ${view} view`}>
            {paths.head}
            {paths.neck}
            {paths.torso}
            {paths.spine}
            {paths.armL}
            {paths.armR}
            {paths.glute}
            {paths.legL}
            {paths.legR}

            {visibleSites.map((s) => {
              const isActive = s.id === safeActive;
              const isRecommended = recommendedRoute && s.type === recommendedRoute;
              const color = SITE_COLORS[s.type];
              const dimmed = recommendedRoute && !isRecommended;
              return (
                <g key={s.id} style={{ cursor: "pointer" }} onClick={() => setActive(s.id)} data-testid={`site-${s.id}`} opacity={dimmed ? 0.35 : 1}>
                  {/* Route-recommended slow halo — pulses on every matching site */}
                  {isRecommended && !isActive && (
                    <circle data-testid={`pulse-${s.id}`} cx={s.cx} cy={s.cy} r="10" fill={color} fillOpacity="0.12">
                      <animate attributeName="r" values="8;14;8" dur="2.2s" repeatCount="indefinite" />
                      <animate attributeName="fill-opacity" values="0.25;0;0.25" dur="2.2s" repeatCount="indefinite" />
                    </circle>
                  )}
                  {/* Click-active pulse (faster, brighter) */}
                  {isActive && (
                    <circle cx={s.cx} cy={s.cy} r="12" fill={color} fillOpacity="0.15">
                      <animate attributeName="r" values="10;16;10" dur="1.6s" repeatCount="indefinite" />
                      <animate attributeName="fill-opacity" values="0.3;0;0.3" dur="1.6s" repeatCount="indefinite" />
                    </circle>
                  )}
                  <circle cx={s.cx} cy={s.cy} r={siteRadius({ isActive, isRecommended })} fill={color} stroke="#050505" strokeWidth="1.5" />
                </g>
              );
            })}

            {/* Legend */}
            <g transform="translate(8, 360)">
              <circle cx="0" cy="0" r="4" fill="#CCFF00" />
              <text x="8" y="3" fill="#A3A3A3" fontSize="9" fontFamily="JetBrains Mono, monospace">SubQ</text>
              <circle cx="46" cy="0" r="4" fill="#00E5FF" />
              <text x="54" y="3" fill="#A3A3A3" fontSize="9" fontFamily="JetBrains Mono, monospace">IM</text>
            </g>
          </svg>
        </div>

        {/* Site details */}
        <div>
          <div className="text-xs font-bold tracking-[0.3em] uppercase text-[#CCFF00] mb-3">/ INJECTION SITES</div>
          <h3 className="font-heading text-2xl font-bold mb-2">{safeSite.label}</h3>
          <div className="inline-block px-3 py-1 rounded-full text-[10px] font-bold uppercase tracking-widest mb-4" style={{ background: `${SITE_COLORS[safeSite.type]}26`, color: SITE_COLORS[safeSite.type] }}>
            {safeSite.type === "SubQ" ? "Subcutaneous" : "Intramuscular"}
          </div>
          <p className="text-sm text-[#A3A3A3] leading-relaxed mb-5">{safeSite.notes}</p>

          <div className="flex flex-wrap gap-2">
            {visibleSites.map((s) => (
              <button
                key={s.id}
                data-testid={`site-btn-${s.id}`}
                onClick={() => setActive(s.id)}
                className={`px-3 py-1.5 rounded-full text-xs font-bold uppercase tracking-wider border transition-colors ${
                  safeActive === s.id
                    ? "bg-[#CCFF00] border-[#CCFF00] text-black"
                    : "border-[#262626] bg-[#121212] text-[#A3A3A3] hover:text-white"
                }`}
              >
                {s.label.split(" ")[0]}
              </button>
            ))}
          </div>

          <p className="text-[10px] text-[#A3A3A3] font-mono-data mt-5">
            Rotate sites each injection to prevent scar tissue. Always clean with alcohol & use a fresh needle.
          </p>
        </div>
      </div>
    </div>
  );
}
